import { render, staticRenderFns } from "./LaunchBox.vue?vue&type=template&id=3ae69326"
import script from "./LaunchBox.vue?vue&type=script&lang=js"
export * from "./LaunchBox.vue?vue&type=script&lang=js"
import style0 from "./LaunchBox.vue?vue&type=style&index=0&id=3ae69326&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports